// @ts-ignore
import React from "react";
import { modalStore } from "library/core/stores/modal";
import BlockMemberModal from "./BlockMemberModal";
import { IMember } from "../_stores/chat/interfaces";

export { default } from "./BlockMemberModal";

export const openBlockMemberModal = (member: IMember) => {
  const handleClose = () => {
    modalStore.closePrimaryModal();
  };

  modalStore.toggleModal(
    <BlockMemberModal isOpen={true} member={member} onClose={handleClose} />,
    true,
    "primary",
    {
      scrollTop: true,
      showNativeCloseButton: false,
    }
  );
};